import { Star } from "lucide-react";
import type { TodayScreenProps } from "../types";
import { ProjectGlyph } from "@/components/icons";
import { ConsolePageHeader } from "./chrome";
import { StatusGroupingContext } from "./context";

/**
 * Today keeps the Things structure (carryover line, planned list, due section, collapsed
 * completed) at Console density: 36px rows, status-style section bands, star title in the top bar.
 */
export function ConsoleTodayScreen(p: TodayScreenProps) {
  const { progress, slots } = p;
  return (
    <StatusGroupingContext.Provider value={false}>
      <ConsolePageHeader
        title="Today"
        icon={<Star className="fill-[var(--star)] text-[var(--star)]" />}
        actions={
          <>
            {progress.total > 0 && (
              <span className="mr-1 inline-flex items-center gap-1.5 text-[12.5px] text-muted-foreground tabular" aria-live="polite" aria-label={`${progress.done} of ${progress.total} done`}>
                <ProjectGlyph progress={progress} className="size-3.5 text-muted-foreground" />
                {progress.done}/{progress.total}
              </span>
            )}
            {slots.focusChip}
            {slots.modeToggle}
            {slots.addTasks}
          </>
        }
      />
      <div data-console-today>
        {slots.carryover && <div data-console-strip className="-mx-4 border-b border-border/70 px-5">{slots.carryover}</div>}
        {slots.plannedList}
        {(p.due.length > 0 || slots.dueOutside) && (
          <div>
            {p.due.length > 0 && slots.dueList}
            {slots.dueOutside && (
              <div data-console-strip className="-mx-4 px-4">
                {slots.dueOutside}
              </div>
            )}
          </div>
        )}
        {slots.completedList && (
          <div data-console-strip data-console-completed className="-mx-4 mt-4 px-4">
            {slots.completedList}
          </div>
        )}
      </div>
    </StatusGroupingContext.Provider>
  );
}
